module.exports = __webpack_public_path__ + "static/media/loba.31165a62.webp";